import styled from 'styled-components';
const DetailStyled = styled.div`
  .main_contain {
    position: relative;
    width: 100%;
    height: 341px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 28px 32px 32px;
    color: #212121;
    .deadLine {
      position: absolute;
      right: 30px;
      top: -40px;
      display: flex;
      align-items: center;
      color: #424242;
      svg {
        margin-right: 10px;
      }
    }
    .main_name {
      padding: 0 0 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #dddddd;
      .time {
        font-size: 16px;
      }
    }
    .main_activity {
      padding-top: 32px;
      color: #212121;
      display: flex;
      > div {
        height: 164px;
        flex: 1;
      }
    }
    .name {
      font-size: 18px;
      font-weight: 600;
    }
    .activity {
      display: flex;
      align-items: center;
    }
    .subTitle {
      margin: 32px 0 0 20px;
      font-size: 16px;
      span {
        display: inline-block;
        font-size: 28px;
        margin-left: 16px;
        margin-bottom: 6px;
        color: #1565c0;
        font-weight: 600;
      }
    }
    .subRegiter {
      margin-left: 35px;
      font-size: 12px;
    }
    .num {
      display: inline-block;
      font-size: 18px;
      font-weight: 600;
      margin: 4px 8px 0 18px;
    }
    .number {
      width: 124px;
    }
    .text {
      display: inline-block;
      margin-left: 5px;
    }
    .downloadDetail {
      display: inline-block;
      margin-top: 3px;
    }
  }
`;
export default DetailStyled;
